
<div *ngIf="newsItem">
    <div class="p-grid">
        <div class="p-col-4 p-lg-2 p-md-2 p-sm-2" *ngIf="canDeleteNews">
            <button pButton type="submit" class="fullwidthbtn" label="REMOVE" (click)="removeNewsItem()"></button>
        </div>
    </div>

    <div class="message-header">NAI Global News</div>
    <div class="card">
        <div class="p-grid">
            <div class="p-col-12 p-lg-3 p-md-4">
                <img [src]="'assets/layout/images/naiimages/news-' + newsItem.NewsMessageTypeID + '.jpg' " />
            </div>
            <div class="p-col-12 p-lg-9 p-md-8">
                <p class="message-caption">NAI Global</p>
                <p class="">Message #{{newsItem.Id}}</p>
                <p class="publishDate">Date:{{newsItem.PubDate | date:'MM/dd/yyyy'}}</p>
                <div class="">
                    <div class="message-header">{{newsItem.HeadLine}}</div>
                    <div [innerHTML]="newsItem.BroadcastBody"></div>
                    <div class="">
                        <div class=""><b>Attachments:</b></div>
                        <div class="p-col-12">
                            <p-table [value]="newsItem.Documents" dataKey="Id" [rows]="20" [responsive]="true"
                                [resizableColumns]="true">

                                <ng-template pTemplate="body" let-doc>
                                    <tr>
                                        <td> <a class="hyperLink" (click)="OpenUrl(doc)">{{doc.Title}}</a>
                                        </td>
                                        <td>
                                            <span [class]=" getIcon(doc) + ' fiv-size-md '"></span>
                                        </td>
                                    </tr>
                                </ng-template>

                            </p-table>
                        </div>
                    </div>
                </div>
            </div>
        </div>  
    </div>
</div>



